module.exports = __webpack_public_path__ + "img/denmark.538669c7.png";